import React from "react"
import * as Components from "../components/components"
import { EventBus } from "../eventbus"
import { NoState } from "../models/interfaces"
import { Rechnungstext } from "../models/rechnungstext"

interface RechnungstextViewProps {
    key: number
    index: number
    rechnungstext: Rechnungstext
    t?: any
}

export class RechnungstextView extends React.Component<RechnungstextViewProps, NoState> {
    onChange(element: string, value: any) {
        EventBus.instance.emit("changeProperty", `rechnungstexte.${this.props.index}.${element}`, value)
    }

    onRemoveClicked = () => {
        EventBus.instance.emit("removeRechnungstext", this.props.index)
    }

    render() {
        const { t } = this.props
        return (
            <div className="rechnungstext">
                <Components.FormGroup label={t("rechnung.rechnungstexte.text.bemerkung.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.rechnungstexte.text.bemerkung.placeholder")}
                        onChange={this.onChange.bind(this, "bemerkung")}
                        value={this.props.rechnungstext.bemerkung}
                        multiline={true}
                    />
                </Components.FormGroup>

                <Components.Row>
                    <Components.Col align={Components.Align.RIGHT}>
                        <Components.Button
                            style={Components.ButtonStyle.SECONDARY}
                            label={t("rechnung.rechnungstexte.textEntfernen")}
                            onClick={this.onRemoveClicked}
                        />
                    </Components.Col>
                </Components.Row>
            </div>
        )
    }
}
